module.exports = __webpack_public_path__ + "img/order-contact-person.3be090f8.png";